import { useEffect, useState } from 'react';
import { AppTable } from '../../../components';
import { PackagingMaterialListHook } from '../../../hooks';
import { PackagingMaterialRow } from '../../../page-components/packaging-materials/packaging-material-row';
import { AddPackageMaterial } from '../../../page-components/packaging-materials';
import { PackagingMaterialService, ToastMessage } from '@utility';

export function PackagingMaterials({
  warehouseId,
  warehouseDetail,
  addRequested,
  onAddRequestedHandled,
}) {
  const [createPopup, setCreatePopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [rowLoading, setRowLoading] = useState({});

  useEffect(() => {
    if (!addRequested) return;
    setSelectedItem(null);
    setCreatePopup(true);
    onAddRequestedHandled?.();
  }, [addRequested, onAddRequestedHandled]);

  const closePopup = () => {
    setCreatePopup(false);
    setSelectedItem(null);
  };

  const {
    data,
    loading,
    totalData,
    totalPages,
    filter,
    filterChanged,
    pageChanged,
    refresh,
    setData,
  } = PackagingMaterialListHook(warehouseId);

  const columns = [
    {
      text: 'Name',
      key: 'name',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Type',
      key: 'type',
      width: 1,
      textAlign: 'left',
    },
    {
      text: 'Dimensions',
      key: 'dimensions',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Weight',
      key: 'weight',
      width: 1,
      textAlign: 'left',
    },
    {
      text: 'Use Case',
      key: 'use_case',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Location',
      key: 'location',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Available',
      key: 'available',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Price',
      key: 'price',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Active',
      key: 'active',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Default',
      key: 'default',
      width: 2,
      textAlign: 'left',
    },
    {
      text: '',
      key: 'action',
      width: 2,
      textAlign: 'left',
    },
  ];

  const editMaterial = item => {
    setSelectedItem(item);
    setCreatePopup(true);
  };

  const updateLoading = (id, value) => {
    setRowLoading(prev => ({
      ...prev,
      [id]: value,
    }));
  };

  const toggleActiveStatus = async item => {
    try {
      updateLoading(item._id, true);
      const payload = {
        status: item.status === 'active' ? 'inactive' : 'active',
      };
      await PackagingMaterialService.update(item._id, payload);
      setData(prevData =>
        prevData.map(pm => {
          if (pm?._id === item?._id) {
            return { ...pm, status: payload.status };
          }
          return pm;
        }),
      );
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      updateLoading(item._id, false);
    }
  };

  const toggleDefaultStatus = async item => {
    try {
      updateLoading(item._id, true);
      const payload = {
        isDefault: !item.isDefault,
      };
      await PackagingMaterialService.update(item._id, payload);
      setData(prevData =>
        prevData.map(pm => {
          if (pm?._id === item?._id) {
            return { ...pm, isDefault: payload.isDefault };
          }
          return pm;
        }),
      );
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      updateLoading(item._id, false);
    }
  };

  return (
    <div className="pt-3">
      <AppTable
        columns={columns}
        data={data}
        loading={loading}
        totalData={totalData}
        totalPages={totalPages}
        RowComponent={
          <PackagingMaterialRow
            rowLoading={rowLoading}
            toggleActiveStatus={toggleActiveStatus}
            toggleDefaultStatus={toggleDefaultStatus}
            editMaterial={editMaterial}
          />
        }
        currentPage={filter.page}
        pageSizeChanged={size => filterChanged('limit', size)}
        pageSize={filter.limit}
        pageChanged={pageChanged}
      />
      <AddPackageMaterial
        open={createPopup}
        onClose={closePopup}
        warehouseDetail={warehouseDetail}
        warehouseId={warehouseId}
        refresh={refresh}
        selectedItem={selectedItem}
      />
    </div>
  );
}
